import React, { PureComponent } from 'react';
import Checkbox from '../checkbox';

const setSelectedTerms = (maxTerm = '-1') => {
  const term = parseInt(maxTerm, 10);
  const planTerms = [0, 6, 12, 18, 24];
  const termsActive = {
    0: false,
    6: false,
    12: false,
    18: false,
    24: false
  };

  if (maxTerm === -1) {
    return termsActive;
  }

  const termIndex = planTerms.findIndex((pt) => pt === term);

  if (term === 0) {
    termsActive[0] = true;
  } else {
    planTerms.slice(1, termIndex + 1).forEach((t) => {
      termsActive[t] = true;
    });
  }

  return termsActive;
};
class PNIGrid extends PureComponent {
  state = {
    termsActive: setSelectedTerms(this.props.selectedPlan)
  }

  handleChecked = (term) => {
    return (e) => {
      const { onPlanSelected } = this.props;
      const termsActive = setSelectedTerms(term);
      termsActive[term] = e.target.checked;
      this.setState({ termsActive }, () => {
        onPlanSelected(term);
      });
    };
  }

  render() {
    return <table className='pni-grid'>
      <tbody>
        <tr>
          <th className='select-plan-term-header'><b>Select Plan Term</b></th>
          <th><b>Case Size</b></th>
          <th><b>Practice Fee</b></th>
        </tr>
        <tr>
          <td className='input-column'>
            <Checkbox
              checked={this.state.termsActive[6]}
              onClick={this.handleChecked(6)}
              data-aid={6}
              id='cbx-pni-six'>
              6 months
            </Checkbox>
          </td>
          <td>All</td>
          <td>5.99%</td>
        </tr>
        <tr>
          <td className='input-column'>
            <Checkbox
              checked={this.state.termsActive[12]}
              onClick={this.handleChecked(12)}
              data-aid={12}
              id='cbx-pni-twelve'>
              12 months
            </Checkbox>
          </td>
          <td>$4,000 to $32,000<br/>Under $4,000</td>
          <td>8.99%<br/>9.99%</td>
        </tr>
        <tr>
          <td className='input-column'>
            <Checkbox
              checked={this.state.termsActive[18]}
              onClick={this.handleChecked(18)}
              data-aid={18}
              id='cbx-pni-eighteen'>
              18 months
            </Checkbox>
          </td>
          <td>All</td>
          <td>13.59%</td>
        </tr>
        <tr>
          <td className='input-column'>
            <Checkbox
              checked={this.state.termsActive[24]}
              onClick={this.handleChecked(24)}
              data-aid={24}
              id='cbx-pni-twenty-fourth'>
              24 months
            </Checkbox>
          </td>
          <td>All</td>
          <td>14.89%</td>
        </tr>
        <tr>
          <td colSpan='3' className='input-column'>
            <div className='ni-not-interested'>
              <Checkbox
                data-aid={0}
                checked={this.state.termsActive[0]}
                onClick={this.handleChecked(0)}
                id='cbx-pni-no-interest'>
                My practice is not interested in Promotional No-Interest Plans
              </Checkbox>
            </div>
          </td>
        </tr>
      </tbody>
    </table>;
  }
}

export default PNIGrid;

